import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})

export class RoutesService {
   goto:any;
   listing_type:any;
  constructor() { }
}
